exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mb-0 {\n  margin-bottom: 10px !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_billing/components/fuel_surcharges/customer_not_associated/customer_not_associated.scss
// module id = 1120
// module chunks = 1